import { useApi } from "auth/useApi3"
import { AppContext } from "components/AppContextProvider"
import ClpTable from "components/ClpTable"
import ContinueDialog from "components/Dialogs/ContinueDialog"
import SuccessDialog from "components/Dialogs/SuccessDialog"
import ErrorDialog from "components/ErrorDialog"
import { GlobalLoaderContext } from "components/GlobalLoadingProvider"
import { apiEndpoints } from "generated/apiEndpoints"
import { useContext, useEffect, useMemo, useState } from "react"
import { StyledTableContainer } from "shared/styled/Global"
import Header from "./components/Header/Header"
import ImportVtrForm from "./components/ImportVtrForm/ImportVtrForm"
import { useTranslation } from "react-i18next"

const ImportVtr = () => {
  const { t } = useTranslation()
  const appContext = useContext(AppContext)

  // states
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  const [showContinueModal, setShowContinueModal] = useState(false)
  const [showErrorModal, setShowErrorModal] = useState(false)

  // a page with a list and a drawer for add/edit form

  // fetch data
  const [addResult, addApi] = useApi()
  const [lastUpdatedDate, lastUpdatedDateFunc] = useApi()
  const [vtrResult, vtrApi] = useApi()

  // send data on submit
  const onAddSubmit = () => {
    addApi.get(apiEndpoints.vehicleregistryadmin.importvtrvehicles)
  }

  // loading when waiting on list
  const loadingContext = useContext(GlobalLoaderContext)
  useEffect(() => {
    loadingContext.setLoading(() => vtrResult.status === 1)
  })

  // load the list on first visit
  useEffect(() => {
    vtrApi.get(apiEndpoints.vehicleregistryadmin.getvehicledetailsbyorgnr)
    return () => {
      vtrApi.leave()
    }
  }, [vtrApi])

  // get last updated date
  useEffect(() => {
    lastUpdatedDateFunc.get(apiEndpoints.vehicleregistry.getlastupdatefromtransportagency)
    return () => {
      lastUpdatedDateFunc.leave()
    }
  }, [lastUpdatedDateFunc])

  // show sidebar
  const openAdd = () => {
    appContext.toggleSideBar(true)
  }

  // update grid on add api call success finish, and close the drawer
  useEffect(() => {
    if (addResult.status === 2) {
      appContext.toggleSideBar(false)
      setShowSuccessModal(true)
      vtrApi.get(apiEndpoints.vehicleregistryadmin.getvehicledetailsbyorgnr)
    }
  }, [addResult, vtrApi])

  // clptable columns
  const columns = [
    {
      accessorKey: "bolag",
      header: t("global.company", "Company")
    },
    {
      accessorKey: "regNr",
      header: t("global.table.regnr", "Reg No")
    },
    {
      accessorKey: "organisationsNr",
      header: t("global.table.organization_no", "Organization no")
    },
    {
      accessorKey: "fordonsTyp",
      header: t("global.vehicle_type", "Vehicle type")
    }
  ]

  const listRows = vtrResult.status === 2 ? vtrResult.data : []

  return (
    <div>
      {showErrorModal && (
        <ErrorDialog
          title={t("vehicleregistry.vehicle_import_failed", "Vehicle import failed")}
          message={t(
            "vehicleregistry.try_importing_the_vehicles_again",
            "Try importing the vehicles again. If the problem persists, contact the administrator."
          )}
        />
      )}
      {showSuccessModal && <SuccessDialog title="Import av fordon lyckades!" />}
      {showContinueModal && (
        <ContinueDialog
          setShowContinueModal={setShowContinueModal}
          onAddSubmit={onAddSubmit}
          result={addResult}
          message={
            t("vehicleregistry.you_will_import", "You will import") +
            " " +
            listRows.length +
            " " +
            t(
              "vehicleregistry.pcs_vehicles_do_you_want_to_complete",
              "pcs vehicles, do you want to complete the import?"
            )
          }
        />
      )}

      <ImportVtrForm setShowContinueModal={setShowContinueModal} listRows={listRows} />
      <Header lastUpdatedDate={lastUpdatedDate?.data} openAdd={openAdd} dashboardResult={listRows} />
      <StyledTableContainer>
        <ClpTable
          columns={columns}
          rows={vtrResult.status === 2 && vtrResult.data}
          loadingState={vtrResult.status}
        />
      </StyledTableContainer>
    </div>
  )
}

export default ImportVtr
